export const formatCurrency = (
  value: number,
  options: Intl.NumberFormatOptions = {}
) => {
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "EUR",
    ...options,
  }).format(value);
};
